import { render } from "./BayPricingManagement.vue?vue&type=template&id=595c885e&scoped=true"
import script from "./BayPricingManagement.vue?vue&type=script&lang=js"
export * from "./BayPricingManagement.vue?vue&type=script&lang=js"

import "./BayPricingManagement.vue?vue&type=style&index=0&id=595c885e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595c885e"]])

export default __exports__